import { alpha } from "@mui/material";

export const sxButtonsStack = (theme: { palette: { mode: string } }) => ({
  width: "100%",
  display: { xs: "none", sm: "flex" },
});
export const sxResultMainBox = (theme: { palette: { mode: string } }) => ({
  mt: { xs: 8, sm: 10 },
  alignSelf: "center",
  width: "100%",
  backgroundImage:
    theme.palette.mode === "light"
      ? 'url("/static/images/templates/templates-images/hero-light.png")'
      : 'url("/static/images/templates/templates-images/hero-dark.png")',
  backgroundSize: "cover",
  borderRadius: "10px",
  outline: "1px solid",
  outlineColor:
    theme.palette.mode === "light"
      ? alpha("#BFCCD9", 0.5)
      : alpha("#9CCCFC", 0.1),
  boxShadow:
    theme.palette.mode === "light"
      ? `0 0 12px 8px ${alpha("#9CCCFC", 0.2)}`
      : `0 0 24px 12px ${alpha("#033363", 0.2)}`,
});
export const sxTextFeedback = (theme: { palette: { mode: string } }) => ({
  fontSize: "clamp(3rem, 10vw, 4rem)",
  color: theme.palette.mode === "light" ? "primary.main" : "primary.light",
});
export const sxMainBox = (theme: { palette: { mode: string } }) => ({
  width: "100%",
  backgroundImage:
    theme.palette.mode === "light"
      ? "linear-gradient(180deg, #CEE5FD, #FFF)"
      : `linear-gradient(#02294F, ${alpha("#090E10", 0)})`, // Assuming 'alpha' is defined
  backgroundSize: "100% 20%",
  backgroundRepeat: "no-repeat",
});
export const sxStackContainer = (theme: { palette: { mode: string } }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  pt: { xs: 14, sm: 20 },
  pb: { xs: 8, sm: 12 },
});
export const sxAnalysisText = (theme: { palette: { mode: string } }) => ({
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  alignSelf: "center",
  textAlign: "center",
  fontSize: "clamp(3.5rem, 10vw, 4rem)",
});
export const sxStackHeader = (theme: { palette: { mode: string } }) => ({
  width: { xs: "100%", sm: "70%" },
});
